import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton, Toolbar } from '@material-ui/core';
import LogoutIcon from '../../common/icons/closeIcon';
import { useLogoutButtonStyles } from './styles';
import { goOut } from '../../../helpers/AuthenticationHelper';

const LogoutButton = ({ ...props }) => {
  const { mobile } = props;
  const classes = useLogoutButtonStyles();
  return (
    <Toolbar className={classes.container}>
      {mobile && (
        <IconButton onClick={goOut}>
          <LogoutIcon size="30px" color="white" />
        </IconButton>
      )}
      {!mobile && (
        <Button
          className={classes.button}
          endIcon={<LogoutIcon size="30px" color="white" />}
          onClick={goOut}
        >
          Cerrar sesión
        </Button>
      )}
    </Toolbar>
  );
};

LogoutButton.propTypes = {
  mobile: PropTypes.bool,
};

export default LogoutButton;
